import { PageHeaderSubtitle } from "../Page";

export function TermsAndConditionsVersion() {
  return <PageHeaderSubtitle>Version 002 dd August 4, 2021</PageHeaderSubtitle>;
}
